<template>
  <div :class="classes">
   <component :is="curComponent" :index="curComponent == 'el-submenu' ? key : data.action" ref="muenItem">
            <template slot="title"  v-if="curComponent == 'el-submenu'">
                <img v-if="data.img" :src="data.img" class="img-icon"/>
                <i v-else-if="data.leftIcon" :class="data.leftIcon"></i>
                <span slot="title">{{data.text}}</span>
                <i v-if="data.icon" :class="data.icon"></i>
            </template>
            <template v-else>
                <div slot="title" @click.native="submenu(item)">
                <img v-if="data.img" :src="data.img" />
                <i v-else-if="data.leftIcon" :class="data.leftIcon"></i>
                <span class="include-number"  >{{data.text}}
                </span>
                <i v-if="data.icon" :class="data.icon"></i>
                </div>
            </template>
            <template v-if="curComponent == 'el-submenu'">
            <template v-for="(item,aIndex) in data.children ">
                <pt-menu-tree-item :data="item" :router="item.action" :index="item.action?item.action:String(aIndex + 1)" :layer="key" :key="key+'-'+aIndex" class="children"
                 @click.native="submenu(item)"></pt-menu-tree-item>
                 <!-- <pt-menu-tree-item :data="item" v-if="curComponent == 'el-submenu' && checkAuth(item.auth)" :index="String(aIndex + 1)" :layer="key" :key="key+'-'+aIndex" @mount-menu-item="updateMenuItem" class="children"
            :selectNumber="selectNumber" @click.native="submenu(item)"></pt-menu-tree-item> -->
            </template>
            </template>
    </component>
    </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-menu-tree-item'

export default {
  name: 'pt-menu-tree-item',
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: String,
      required: true
    },
    layer: {
      type: String
    },
    selectNumber: {
      type: [Number, String]
    }
  },
  computed: {
    key () {
      return this.layer ? this.layer + '-' + this.index : this.index
    },
    classes () {
      return `${prefixCls}`
    },
    curComponent () {
      return this.data.children ? 'el-submenu' : 'el-menu-item'
    }
  },
  methods: {
    // 根据子菜单筛选
    submenu (item) {
      this.$router.push(item.action)
    },
    getMenuItem (menuItem) {
      this.$emit('mount-menu-item', menuItem)
    }
  },
  mounted () {
    if (this.curComponent === 'el-menu-item') {
      this.$emit('mount-menu-item', this.$refs.muenItem)
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-menu-tree-item{
    .el-submenu__title{
        color:#fff;
        i{
            color:#fff;
            margin-right:10px;
        }
    }
    .el-submenu__title{
        &:hover{
         background-color:rgba(234,181,118,0.6)
        }
    }
    .el-menu--inline{
        background-color:rgba(255,255,255,0);
        .el-menu-item{
            color:#fff;
            &:hover{
                background-color:rgba(234,181,118,0.6)
            }
            &.is-active{
                color:#333!important;
                background-color:#edbe81!important;
            }
        }
    }
}
</style>
